export enum ContactMethod {
  Phone = 'phone',
  MobilePhone = 'mobilePhone',
  AccountPhone = 'accountPhone',
  Email = 'email',
  Linkedin = 'linkedin',
  Website = 'website',
}

export enum ContactStatus {
  None = 'none',
  Valid = 'valid',
  Invalid = 'invalid',
  Warning = 'warning',
}

export type ContactMethodMeta = {
  icon: JSX.Element;
  buttonClass?: string;
};
